import * as i0 from '@angular/core';
import * as i1 from './bs-dropdown.module';
import * as i2 from './bs-dropdown-menu.directive';
import * as i3 from './bs-dropdown-toggle.directive';
import * as i4 from './bs-dropdown-container.component';
import * as i5 from './bs-dropdown.directive';
export const BsDropdownModuleNgFactory:i0.NgModuleFactory<i1.BsDropdownModule> = (null as any);
var _decl0_0:i2.BsDropdownMenuDirective = (<any>(null as any));
var _decl0_1:i3.BsDropdownToggleDirective = (<any>(null as any));
var _decl0_2:i4.BsDropdownContainerComponent = (<any>(null as any));
var _decl0_3:i5.BsDropdownDirective = (<any>(null as any));
var _decl0_4:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_5:i0.ElementRef<any> = (<any>(null as any));
function _View_BsDropdownContainerComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_BsDropdownContainerComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_2.direction === 'up');
  currVal_0;
  const currVal_1:any = (_decl0_2.direction === 'down');
  currVal_1;
  const currVal_2:any = _decl0_2.isOpen;
  currVal_2;
  const currVal_3:any = _decl0_2.isOpen;
  currVal_3;
}
